<div class="m-4">
  <h2 class="mb-4" i18n="@@outcome-approval-contractor.approve-all">Godkänn samtliga körorder</h2>
  <p class="mb-5" i18n="@@outcome-approval-contractor..confirm">Detta godkänner samtliga körordrar på denna beställning. Vill du gå vidare?</p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@outcome-approval-contractor.no">Nej</button>
    <button class="btn btn-primary btn-min-width" id="approveBtn" type="button" (click)="approve()" [disabled]="buttonsDisabled" i18n="@@outcome-approval-contractor.yes">Ja</button>
  </div>
</div>
